module.exports = __webpack_public_path__ + "img/icon-stake.28dfcc62.svg";